import React, { Component, PropTypes } from 'react'

import './Auth.scss'
import SignUp from 'screens/SignUp'
import Login from 'screens/Login'

import { LogOnMount } from '@amplitude/react-amplitude'

class Auth extends Component {
  componentWillMount () {
    const {
      loggedIn,
      next,
      replace
    } = this.props

    if (loggedIn) {
      replace(next)
    }
  }

  render () {
    const {
      type
    } = this.props

    return (
      <div className='Auth'>
        <LogOnMount eventType="sign-up-screen" />

        {type === 'signup'
          ? <SignUp {...this.props} />
          : <Login {...this.props} />
        }
      </div>
    )
  }
}

Auth.displayName = 'Auth'
Auth.propTypes = {
  type: PropTypes.oneOf(['signup', 'login']).isRequired
}
Auth.defaultProps = {
  type: 'signup',
  next: '/'
}

export default Auth



// WEBPACK FOOTER //
// ./src/screens/App/screens/Auth/Auth.js